/**
 * Build multipart FormData for driver complete_job (quantities, optional JSON sub_jobs, geotagged photos).
 */
export function buildCompleteJobFormData({
  jobId,
  vehicleId,
  dieselDelivered,
  defDelivered,
  dyedDelivered,
  equipmentCount,
  completionNotes,
  latitude,
  longitude,
  subJobsPayload,
  deliveryPhotos,
}) {
  const fd = new FormData();
  fd.append('job_id', jobId);
  fd.append('vehicle_id', String(vehicleId ?? ''));
  fd.append('diesel_delivered', String(dieselDelivered ?? 0));
  fd.append('def_delivered', String(defDelivered ?? 0));
  fd.append('dyed_delivered', String(dyedDelivered ?? 0));
  if (equipmentCount != null && String(equipmentCount).trim() !== '') {
    fd.append('equipment_count', String(equipmentCount).trim());
  }
  fd.append('completion_notes', completionNotes ?? '');
  if (latitude != null && longitude != null) {
    fd.append('latitude', String(latitude));
    fd.append('longitude', String(longitude));
  }
  if (subJobsPayload && subJobsPayload.length > 0) {
    fd.append('sub_jobs', JSON.stringify(subJobsPayload));
  }
  const meta = [];
  (deliveryPhotos || []).forEach((p) => {
    fd.append('delivery_photos', p.file);
    meta.push({
      latitude: p.latitude != null ? p.latitude : null,
      longitude: p.longitude != null ? p.longitude : null,
    });
  });
  fd.append('delivery_photo_meta', JSON.stringify(meta));
  return fd;
}
